module.exports = __webpack_public_path__ + "img/meizu2.492ad5d6.png";